<template>
     <div class="cert">
        <!-- <div class="heading2-section">
            Achievements & Certifications
        </div> -->
    <form>
   
        <div class="mb-3">
        <label class="form-label">Name</label>
        <input type="text" v-model="ac.name" placeholder="Certificate Name" class="form-control">
        </div>
        <div class="mb-3">
        <label class="form-label">Issuer</label>
        <input type="text" v-model="ac.issuer" placeholder="Name of Issuer" class="form-control">
        </div>
           <div class="mb-3">
            <label class="form-label">URL</label>
            <input type="text" v-model="ac.url" placeholder="Link to Certificate" class="form-control">
            </div>
        <div class="mb-3">
        <label class="form-label">Received</label>
            <div class="select-date">
            <!-- start month -->
            <select class="form-select" v-model="dates.startMonth" id="monthSelect">
                <!-- <option selected disabled>Select Month</option> -->
                <option>January</option>
                <option>February</option>
                <option>March</option>
                <option>April</option>
                <option>May</option>
                <option>June</option>
                <option>July</option>
                <option>August</option>
                <option>September</option>
                <option>October</option>
                <option>November</option>
                <option>December</option>
            </select>
            <!-- start year -->
              <select class="form-select" v-model="dates.startYear" id="yearSelect">
                <!-- <option selected disabled>Select Year</option> -->
                <option v-for="year in years" :key="year">{{ year }}</option>
            </select>
        </div>
        </div>

        
         <div class="form-buttons mb-3">
            <div class="button-subgroup" v-if="isAdding">
                <button type="submit" class="btn btn-default primary-btn" v-if="loading && buttonClicked" disabled>Adding Achievement...</button>
                <button type="submit" class="btn btn-default primary-btn" @click.prevent="addAchievement()" v-else>Add Achievement</button>
            </div>
            <div class="button-subgroup" v-else>
                <button type="submit" class="btn btn-default primary-btn" v-if="loading && buttonClicked" disabled>Updating Achievement...</button>
                <button type="submit" class="btn btn-default primary-btn" @click.prevent="editAchievement()" v-else>Update Achievement</button>
                <button type="submit" class="btn btn-default primary-btn badge-cancel"v-if="!loading && !buttonClicked" @click.prevent="cancel()">Cancel Edit</button>
            </div>
        </div>
         <!-- errors -->
        <div class="errors" v-if="hasErrors">
            <div class="error" v-for="error in errors">{{ error }}</div>
        </div>
        <!-- errors --> 
    </form>
    <!-- START history -->
    <div class="history">
        <!-- histories -->
        <div class="hist" v-for="achievement in achievements" :key="achievement.achievementId">
            <div class="hist-details">
                <div class="hist-title">{{achievement.name}}</div>
                <div class="hist-company">{{ achievement.issuer }}</div>
                <div class="hist-date">{{achievement.receivedDate}}</div>
            </div>
            <div class="hist-controls">
                <button class="btn btn-default button-primary" @click.prevent="reviewAchievement(achievement)"  style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">Edit</button>
                <button class="btn btn-danger" :id="achievement.achievementId" @click.prevent="deleteAchievement(achievement.achievementId)" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;">Delete</button>
            </div>
        </div>
      
        <!--  -->
    </div>
    <!-- END OF HISTORY -->
    </div>
     <CustomConfirmationMessageModal :title="modal.caption"
            ref="acConfirmModal"
           :body="modal.message"
           :button-label="modalButtonLabel"
           :close-modal="() => closeModal()"
           :modal-id="modalId"/>
    <WarningOptionsModal
            ref="acDelModal"
            :body="this.delModal.body"
            :title="this.delModal.title"
            :close-modal="this.delModal.closeModal"
            :yes-selected="this.delModal.yesSelected"
            :yes-button-label="this.delModal.yesButtonLabel"
            :no-button-label="this.delModal.noButtonLabel"
            :modal-id="this.delModal.modalId"
            loading-button-label="Deleting Achievement..."
            />
</template>
<script>
    import { addAchievementAsync, editAchievementAsync, deleteAchievementAsync } from '@/services/cvbuilderService';
     import CustomConfirmationMessageModal from '@/components/modals/CustomConfirmationMessageModal.vue';
    import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
    import WarningOptionsModal from '@/components/modals/WarningOptionsModal.vue';
export default {
    components:{
        LoadingIndicator,CustomConfirmationMessageModal,WarningOptionsModal
    },
     data() {
    return {
        isAdding: true,
     ac:{
                name:"",
                issuer:"",
                url:"",
                receivedDate:""
            },
        dates:{
            startMonth:"",
            startYear:""
        },
        modal:{
                caption:"",
                message:""
            },
        delModal:{
            title:"",
            body:"",
            modalId:"delWork",
            yesButtonLabel:"Delete Achievement",
            noButtonLabel:"Cancel",
            closeModal: null,
            yesSelected: null
        },
         selectedWorkId:"",
            errors:[],
            loading:false,
            buttonClicked:false,
            hasErrors:false,
            modalButtonLabel:'Close',
            modalId:"addAc",
      years: []
    };
  },
  created() {
    const currentYear = new Date().getFullYear();
    for (let y = currentYear; y >= 1980; y--) {
      this.years.push(y);
    }
  },
  computed:{
     achievements(){
            var eds = this.$store.getters["cvbuilder/getCVInformation"]?.achievements || [];
            return eds;
        }
  },
  methods:{
    shortMonth(month){
            const date = new Date(`${month} 1, 2000`); // dummy day/year
            return date.toLocaleString('en-US', { month: 'short' });
        },
    setIdForDelete(achievementId){
            this.delModal.title = "Delete Achievement",
            this.delModal.body = "Are you sure you want to delete this achievement?"
            this.delModal.yesSelected = async() => await this.deleteAchievement(achievementId);
            this.delModal.closeModal = () => this.closeDelModal();
            this.showDelModal();
        },
     async deleteIdFromModalButton(){
            await this.deleteAchievement(this.idForDelete);
        },
    updateDeleteButton(id, isDisabled, label){
            let btn = document.getElementById(id);
            btn.disabled = isDisabled;
            btn.innerHTML = label;
            
        },
        resetOnNewDelete(){
                this.loading = true;
                this.hasErrors = false;
                this.errors = [];
        },
        stopOnDeleteError(message){
            this.errors.push(message);
            this.hasErrors = true; 
            this.loading = false;
            this.clearErrors();
        },
    async deleteAchievement(achievementId){
            try{     
                this.resetOnNewDelete();
                this.updateDeleteButton(achievementId,true,"Deleting...");
                this.resetOnBadgeSelection();
                var data = await deleteAchievementAsync(achievementId);
                if(!data.success){
                    throw new Error(data.message, {cause: data.caption})
                }else{
                    this.closeDelModal();
                    this.$store.dispatch("cvbuilder/removeAchievement",achievementId);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                    this.ac = {
                                   name:"",
                                    issuer:"",
                                    url:"",
                                    receivedDate:""
                                };
                    this.dates = {
                                startMonth:"",
                                startYear:""
                            };
                }
            }catch(e){
               this.stopOnDeleteError(e.message);             
                this.updateDeleteButton(achievementId,false,"Delete");
            }
        },
        async editAchievement(){
            try{  
                var result = this.resolveAndValidateDates();
                if (!result) {
                    return; // stop execution, errors are already set
                 }
                 var startDate = result;

                 var body = {
                   name: this.ac.name, 
                    issuer: this.ac.issuer,
                    url: this.ac.url,
                    receivedDate: startDate,       
                    achievementId: this.selectedAcId
                }
                this.resetOnNewSubmit();   
                var data = await editAchievementAsync(body);
                if(!data.success){
                    if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                        });
                        this.hasErrors = true;
                        this.buttonClicked = false;
                        this.loading = false;
                        this.clearErrors();
                        return;
                    }
                throw new Error(data.message, {cause: data.caption})
                }else{
                    this.$store.dispatch("cvbuilder/updateAchievement", body);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                    this.ac = {
                                   name:"",
                                    issuer:"",
                                    url:"",
                                    receivedDate:"",
                                };
                    this.dates = {
                                startMonth:"",
                                startYear:""
                            };
                }
            }catch(e){
                this.loading = false;
                this.buttonClicked = false;
                let message = e.message || "Something went wrong. Please try later";
                this.errors.push(message);
                this.hasErrors = true;
                this.clearErrors();
            }
        },
        async addAchievement(){
            try{   
                var result = this.resolveAndValidateDates();
                if (!result) {
                    return; // stop execution, errors are already set
                 }
                 var startDate = result;
                var body = {
                    name: this.ac.name, 
                    issuer: this.ac.issuer,
                    url: this.ac.url,
                    receivedDate: startDate
                }
                this.resetOnNewSubmit();   
                var data = await addAchievementAsync(body);
                if(!data.success){
                    if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                        });
                        this.hasErrors = true;
                        this.buttonClicked = false;
                        this.loading = false;
                        this.clearErrors();
                        return;
                    }
                throw new Error(data.message, {cause: data.caption})
                }else{
                    this.$store.dispatch("cvbuilder/addNewAchievement", data.achievement);
                    this.loading = false;
                    this.buttonClicked = false;
                    this.isAdding = true;
                     this.work = {
                                   name:"",
                                    issuer:"",
                                    url:"",
                                    receivedDate:""
                                };
                    this.dates = {
                                startMonth:"",
                                startYear:""
                            };
                     this.ac = {
                            name:"",
                            issuer:"",
                            url:"",
                            receivedDate:""
                        };
                }
            }catch(e){
                this.loading = false;
                this.buttonClicked = false;
                let message = e.message || "Something went wrong. Please try later";
                this.errors.push(message);
                this.hasErrors = true;
                this.clearErrors();
            }
        },
        resolveAndValidateDates(){
                    var startDate =
                this.dates.startMonth && this.dates.startYear
                    ? `${this.shortMonth(this.dates.startMonth)} ${this.dates.startYear}`
                    : '';

                // Simple validation
                if (!startDate) {
                    this.errors = ['Please select a valid month and year.'];
                    this.hasErrors = true;
                    this.clearErrors();
                    return;
                }
                return startDate
        },
        reviewAchievement(achievement){
            this.isAdding = false;
            this.ac = {
                name: achievement.name,
                issuer: achievement.issuer,
                url: achievement.url,
                receivedDate: ""
            };
            this.selectedAcId = achievement.achievementId
        },
         cancel(){
            this.isAdding = true;
            this.ac = {
               name:"",
                issuer:"",
                url:"",
                receivedDate:""
            };
        },
         closeModal(){
        if (this.$refs.acConfirmModal && typeof this.$refs.acConfirmModal.hide === 'function') {
        this.$refs.acConfirmModal.hide();
        }
        },
        showModal(){
            this.$refs.acConfirmModal.show();
        },
         closeDelModal(){
        if (this.$refs.acDelModal && typeof this.$refs.acDelModal.hide === 'function') {
        this.$refs.acDelModal.hide();
        }
        },
        showDelModal(){
            this.$refs.acDelModal.show();
        },
        resetOnNewSubmit(){
                this.loading = true;
                this.buttonClicked = true;
                this.hasErrors = false;
                this.errors = [];
        },
         resetOnBadgeSelection(){
                this.loading = true;
                //this.buttonClicked = true; //cause no form button is clicked
                this.hasErrors = false;
                this.errors = [];
        },
        clearErrors(){
            setTimeout(() => {
                this.errors = [];
                this.hasErrors = false;
            }, 3000);          
        }


  }
}
</script>
<style scoped>
    .select-date{
    display: flex;
    column-gap:0.5rem;
    width:50%;
    
}

@media (max-width:768px) {
    .select-date{
    
    width:50%;
    
}
}
</style>